import React, {useState, useRef, useContext, useEffect} from 'react'
import {
  Grid,
  Typography,
  TextField,
  IconButton,
  List,
  ListItem,
  Divider,
  Popover,
  CircularProgress,
} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import '../../../styles/Reservation/Reservation.scss'
import './ReservedForOptions.styles.scss'
import {ReservationContext} from '../../../context/Reservation'
import useCalendarViewContext from '../../../context/CalendarView'
import ReservedForFieldValues from './ReservedForFieldValues'
import LoadingIndicator from '../../ReservationConfiguration/LoadingIcon'
import _ from 'lodash'

export default function ReservedForOptions({gantt}) {
  const [edit, setEdit] = useState(false)
  const [popAnchor, setPopAnchor] = useState(null)
  const {reservedForFields, loadReservedForFields, configuration, reservation, update} = useContext(
    ReservationContext
  )

  const {views, viewData} = useCalendarViewContext()
  //const [reservation.selected_field, setSelectedField] = useState(null)
  const [search, setSearch] = useState('')
  const [searchQuery, setSearchQuery] = useState('')

  const handleClose = () => {
    setPopAnchor(null)
    setEdit(false)
  }

  const handleSearch = () => {
    if (search.length === 0 || search.length >= 3) {
      setSearchQuery(search)
    }
  }

  const handleSearchClose = () => {
    setSearch('')
    setSearchQuery('')
  }

  const filterReservedForByGroup = reservedFor => {
    if (gantt) {
      const reserveForArr = reservedFor.filter(r => {
        const entity_ids = r.field_details.map(d => d.entity_id)
        return entity_ids.includes(viewData.selectedView.group_view.entity_id)
      })
      return reserveForArr
    }
    return reservedFor
  }

  const getSelectedField = (data, selectedField) => {
    let op
    data.forEach(field => {
      field.field_details.forEach(detail => {
        if (detail.field_id.toString() === selectedField.toString()) {
          op = field
        }
      })
    })
    return op
  }

  useEffect(() => {
    if (
      reservedForFields.data.length &&
      _.isEmpty(reservation.reserve_for_field) &&
      !reservation.reserved_for.field_id
    ) {
      update('selected_field', filterReservedForByGroup(reservedForFields.data)[0])
      update('reserve_for_field', filterReservedForByGroup(reservedForFields.data)[0])
    } else if (reservedForFields.data.length && reservation.reserved_for.field_id) {
      update(
        'selected_field',
        getSelectedField(reservedForFields.data, reservation.reserved_for.field_id)
      )
      update(
        'reserve_for_field',
        getSelectedField(reservedForFields.data, reservation.reserved_for.field_id)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservedForFields, reservation.reserved_for.field_id])

  useEffect(() => {
    const account_id = localStorage.getItem('account_id')
    if (!!account_id) {
      loadReservedForFields(account_id)
    }
  }, [loadReservedForFields])

  const handleClickField = (e, field) => {
    update('selected_field', field)
    update('reserve_for_field', field)
    setSearchQuery('')
    setSearch('')
  }

  return (
    <>
      <div
        onClick={e => {
          if (!reservation.is_edit === true) {
            setPopAnchor(e.currentTarget)
          }
        }}
      >
        {!edit && (
          <div
            className={
              reservation.is_edit === true
                ? 'ap-box ap-box--outlined reserved-for-disabled'
                : 'ap-box ap-box--outlined curser-pointer-reserved-for'
            }
            style={{minWidth: 240}}
          >
            {!gantt && (
              <Typography className="ap-typography ap-typography--xs" style={{marginBottom: 4}}>
                For
              </Typography>
            )}
            <Typography className="ap-typography ap-typography--sm">
              {reservation.reserved_for.name ? reservation.reserved_for.name : 'Add Reserved For'}
            </Typography>
          </div>
        )}
      </div>
      <Popover
        open={Boolean(popAnchor)}
        anchorEl={popAnchor}
        onClose={handleClose}
        className="c-res-mod "
      >
        {
          <div className="ap-box ap-box--outlined" style={{width: 320, padding: 0, minHeight: 290}}>
            <div style={{borderBottom: '1px solid black', padding: '8px 16px'}}>
              {!gantt && (
                <Typography className="ap-typography ap-typography--xs" style={{marginBottom: 4}}>
                  For
                </Typography>
              )}
              <Grid container>
                <Grid item className="" xs={search ? 10 : 11}>
                  <TextField
                    id="standard-basic"
                    placeholder="Type to search"
                    className="reserved-search-input"
                    value={search}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        handleSearch(e)
                      }
                    }}
                    onChange={e => {
                      setSearch(e.target.value)
                    }}
                    InputProps={{disableUnderline: true}}
                  />
                </Grid>
                {search && (
                  <Grid item className="" xs={1}>
                    <IconButton
                      type="submit"
                      className="ap-icon-button"
                      underline={false}
                      aria-label="search"
                      style={{padding: 0}}
                      onClick={handleSearchClose}
                      disableRipple
                    >
                      <CloseIcon />
                    </IconButton>
                  </Grid>
                )}
                <Grid item className="" xs={1}>
                  <IconButton
                    type="submit"
                    className="ap-icon-button"
                    underline="false"
                    aria-label="search"
                    style={{padding: 0}}
                    onClick={handleSearch}
                  >
                    <SearchIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </div>
            <Grid container style={{}}>
              <Grid item className="" xs={6}>
                <List style={{paddingLeft: 9}}>
                  {(!Array.isArray(reservedForFields.data) || reservedForFields.isLoading) && (
                    <LoadingIndicator style={{width: '100%'}} />
                  )}
                  {Array.isArray(reservedForFields.data) &&
                    !reservedForFields.isLoading &&
                    !_.isEmpty(reservedForFields.data) &&
                    filterReservedForByGroup(reservedForFields.data).map(field => {
                      return (
                        <>
                          <ListItem
                            style={{cursor: 'pointer'}}
                            className={
                              reservation.selected_field &&
                              reservation.selected_field.name === field.name
                                ? 'selected-field'
                                : ''
                            }
                            onClick={e => handleClickField(e, field)}
                          >
                            <Typography className="ap-typography ap-typography--sm">
                              {field.field_type === 'ApUserField' ? 'System Users' : field.name}
                            </Typography>
                          </ListItem>
                          <Divider />
                        </>
                      )
                    })}
                  {Array.isArray(reservedForFields.data) &&
                    !reservedForFields.isLoading &&
                    _.isEmpty(filterReservedForByGroup(reservedForFields.data)) &&
                    'Data is empty, Please Check Permissions'}
                </List>
              </Grid>
              <Grid
                item
                className="ap-scrollbar"
                xs={6}
                style={{
                  height: `${gantt ? '245px' : '230px'}`,
                  overflowY: 'auto',
                  boxShadow: '0 6px 10px 0 rgba(0, 0, 0, 0.25)',
                  borderRadius: '11px',
                }}
              >
                <ReservedForFieldValues
                  setPopAnchor={setPopAnchor}
                  selectedField={reservation.selected_field}
                  search={searchQuery}
                />
              </Grid>
            </Grid>
          </div>
        }
      </Popover>
    </>
  )
}
